<script>
  import MainHeader from './main-header.svelte';
  import Body from './body.svelte';
  import Aside from './aside.svelte';
  import Footer from './footer.svelte';
</script>

<div class="container">
  <MainHeader />
  <Body />
  <Aside />
  <Footer />
</div>

<style>
  :global(html, body) {
    scroll-behavior: smooth;
    margin: 0px;
    height: 100%;
    font-family: 'S-CoreDream';
    font-weight: 100;
    box-sizing: border-box;
  }
  :global(body) {
    padding: 0px;
  }
  .container {
    width: 100%;
    position: relative;
    background-color: white;
  }
</style>
